import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

import BankAccountMetrics from './BankAccountMetricsModel';

const CreditLineLiveRecord = Record({
  balance: 0,
  metrics: null,
  updatedAt: new Date(0),
});

export default class CreditLineLive extends CreditLineLiveRecord {
  static deserialize(jsonObject = {}) {
    const mapProperties = {
      metrics: BankAccountMetrics.deserialize,
      updatedAt: Hydrator.timestamp2Date,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new CreditLineLive(hydrated);
  }
}
